import { useState, useEffect } from "react";
import {
  Box,
  Button,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import { UseSellReport } from "./UseSellReport";
import DatePickerCom from "./DatePickerCom";
import ProductListGrid from "./ProductListGrid";
import GroupSelect from "./GroupSelect";
import CategoryAutoComplete from "../../basic-information/productCategory/CategoryAutoComplete";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import SearchComOff from "../../ContentManagement/firstPage/HomeOffer/SearchComOff";
import BrandSearchCom from "../../basic-information/brand/BrandSearchCom";
import { useSnackbar } from "notistack";
import { rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function ProductReport(props) {
  const { enqueueSnackbar } = useSnackbar();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { validate, GetItemReport, GetProductList } = UseSellReport();
  const [name, setName] = useState("");
  const [page, setPage] = useState(1);
  const [msScrollCk, setMsScrollCk] = useState(false);
  const [productRes, setProductRes] = useState();
  const [state, setState] = useState({
    productID: 0,
    brandID: 0,
    groupID: 0,
    categoryID: 0,
    date1: undefined,
    date2: undefined,
  });

  const [errorState, setErrorState] = useState({
    productID: false,
    brandID: false,
    groupID: false,
    categoryID: false,
    date1: false,
    date2: false,
  });

  const { isSmall } = useBreakpoints();

  const handleChange = (panel) => (event, isExpanded) => {
    props.setExpanded(isExpanded ? panel : false);
    if (isExpanded) {
      const element = document.getElementById("panel4");
      setTimeout(() => {
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 500);
    }
  };

  useEffect(() => {
    if (msScrollCk) {
      const element = document.getElementById("scrollTo");
      setTimeout(() => {
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
          setMsScrollCk(false);
        }
      }, 500);
    }
  }, [msScrollCk]);

  useEffect(() => {
    if (state.date1 && state.date2 && page > 0) {
      let sendModel = {
        pageCondition: { page: page },
        products: state,
      };
      GetProductList(sendModel, (callback) => {
        setProductRes(callback);
      });
    }
  }, [page]);

  return (
    <Accordion
      expanded={props.expanded === "panel4"}
      id="panel4"
      onChange={handleChange("panel4")}
      style={{
        margin: isSmall ? 0 : "20px",
        marginBottom: isSmall && "20px",
        paddingBottom: "15px",
      }}
    >
      <AccordionSummary
        // onClick={() => props.setExpanded("panel1")}
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <FiberManualRecordIcon color="secondary" fontSize="small" />
          <Typography sx={{ ml: 1 }} color="secondary" variant="subtitle1">
            گزارش فروش محصول{" "}
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            p: 1,
            py: 0,
            borderRadius: 2,
          }}
        >
          <DatePickerCom state={state} setState={setState} />
          <Box
            display="grid"
            gridTemplateColumns="repeat(12, 1fr)"
            gap={3}
            sx={{
              mt: 3,
            }}
          >
            <Box gridColumn={isSmall ? "span 12" : "span 10"}>
              <SearchComOff
                sell
                article={isSmall ? true : false}
                productID={state.productID}
                productModel={state}
                setProductModel={setState}
                validation={errorState.productID}
              />
            </Box>
            {props.expanded === "panel4" && (
              <Box gridColumn={isSmall ? "span 12" : "span 4"}>
                <CategoryAutoComplete
                  setName={setName}
                  validation={errorState.categoryID}
                  selectedCategoryID={state.categoryID}
                  setter={setState}
                  lvl1State={state}
                  Offer
                ></CategoryAutoComplete>
              </Box>
            )}
            {!isSmall && <Box gridColumn="span 8"></Box>}
            {props.expanded === "panel4" && (
              <Box gridColumn={isSmall ? "span 12" : "span 4"}>
                <BrandSearchCom
                  setName={setName}
                  validation={errorState.brandID}
                  selectedBrandID={state.brandID}
                  setter={setState}
                  lvl1State={state}
                  Offer
                ></BrandSearchCom>
              </Box>
            )}
            {!isSmall && <Box gridColumn="span 8"></Box>}
            {props.expanded === "panel4" && (
              <Box gridColumn="span 12">
                <GroupSelect
                  selectedGroupID={state.groupID && state.groupID}
                  setter={setState}
                  lvl1State={state}
                ></GroupSelect>
              </Box>
            )}
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              gridColumn="span 12"
            >
              <Button
                // disabled={!state.date1 || !state.date2 ? true : false}
                sx={{ width: "80px", mr: 2 }}
                onClick={() => {
                  setProductRes();
                  setState({
                    brandID: 0,
                    productID: 0,
                    groupID: 0,
                    categoryID: 0,
                    date1: undefined,
                    date2: undefined,
                  });
                }}
                color="secondary"
                variant="outlined"
              >
                جدید
              </Button>
              <Button
                disabled={!state.date1 || !state.date2 ? true : false}
                sx={{ width: "80px" }}
                onClick={() => {
                  if (!state.date1 || !state.date2) {
                    enqueueSnackbar("لطفا تاریخ را وارد کنید", {
                      variant: "error",
                      autoHideDuration: 2000,
                      preventDuplicate: true,
                    });
                    return;
                  } else {
                    let sendModel = {
                      pageCondition: { page: page },
                      products: state,
                    };
                    setProgress(true);
                    // return;
                    GetProductList(sendModel, (callback) => {
                      setProgress(false);
                      if (callback.products.length == 0) {
                        setProductRes();
                        setMsScrollCk(false);
                        enqueueSnackbar("گزارشی یافت نشد", {
                          variant: "error",
                          autoHideDuration: 2000,
                          preventDuplicate: true,
                        });
                        return;
                      }
                      setProductRes(callback);
                      setMsScrollCk(true);
                    });
                  }
                }}
                variant="contained"
              >
                نمایش
              </Button>
            </Box>
            {productRes && (
              <Box id="scrollTo" gridColumn="span 12">
                <ProductListGrid
                  callbackProduct={(call) => {
                    let Newstate = {
                      productID: call,
                      brandID: 0,
                      groupID: 0,
                      categoryID: 0,
                      date1: state.date1,
                      date2: state.date2,
                    };
                    setProgress(true);
                    GetItemReport(Newstate, (resauls) => {
                      props.setProductDetail(resauls);
                      props.setDetailShow({ show: true });
                      setProgress(false);
                    });
                  }}
                  page={page}
                  setPage={setPage}
                  state={state}
                  productRes={productRes}
                />
              </Box>
            )}
          </Box>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
}
